import UAParser from 'ua-parser-js'

const DEFAULT_TYPE = 'desktop'

export const getDeviceType = (userAgent: string | undefined) => {
  if (!userAgent) {
    return ''
  }

  const parser = new UAParser(userAgent)
  const { type } = parser.getDevice()

  return type || DEFAULT_TYPE
}
